import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import React, { useState } from "react";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../../nodeInstance";
import UpdateDetailsPopup from "./UpdateDetailsPopup/UpdateDetailsPopup";
import DocumentUploadFilePopUp from "../../Iqama/FileDocumentPopUp/FileDocumentPopUp";

export default function ListAppliedList({
  token,
  titles = [],
  list = [],
  updateData,
}) {
  const [popOpenDoc, setPopUpDoc] = useState(false);
  const [Popup, setPopUp] = useState(false);
  const [searchWords, setSearchWords] = useState([]);
  const [selectList, setSeletedList] = useState([]);
  const [status, setStatus] = useState(0);
  const dispatch = useDispatch();

  const [statusCode, setStatusCode] = useState();

  const [checkedItems, setCheckedItems] = useState({});
  const [newCurrentList, setNewCurrentList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [popUpFlag, setPopUpFlag] = useState(false);
  const [indexValue, setIndex] = useState(10);
  const [listChecked, setItemList] = useState([]);

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(newCurrentList || []);

  var titleList = [
    "S.NO.",
    "VISA PROVIDER",
    "CLIENT NAME",
    "EMPLOYEE COUNT",
    "SPONSOR ID",
    "STATUS",
  ];

  const apiCall = () => {
    updateData();
    setCheckedItems({});
  };

  const popOpen = () => {
    if (
      Object.entries(checkedItems)
        .filter(([emp_id, isChecked]) => isChecked)
        .map(([emp_id]) => emp_id).length === 0
    ) {
      dispatch(
        setAppError({
          msg: "Please select Check box",
        })
      );
    } else {
      if (dataList.length !== 0) {
        console.log(popUpFlag);
        if (popUpFlag === false) {
          console.log("popUpFlag", popUpFlag);
          drivingApi({
            employee_id: dataList.map((e) => e.employee_id),
            driving_status: statusCode,
          });
        } else {
          console.log("popUpFlag", popUpFlag);
          console.log(popUpFlag);
          setPopUp(true);
        }
      } else {
        dispatch(
          setAppError({
            msg: "Please Select Vaild Emp",
          })
        );
      }
    }
  };

  const popOpenIssued = () => {
    const data = listChecked.filter((indexData) =>
      indexData.driving_status_value === null
        ? ""
        : indexData.driving_status_value.toString() === "5"
    );
    console.log(data);
    setDataList(data);
    setPopUpFlag(false);
    setStatusCode("6");
    if (
      Object.entries(checkedItems)
        .filter(([emp_id, isChecked]) => isChecked)
        .map(([emp_id]) => emp_id).length === 0
    ) {
      dispatch(
        setAppError({
          msg: "Please select Check box",
        })
      );
    } else {
      if (data.length !== 0) {
        console.log(popUpFlag);
        if (popUpFlag === false) {
          console.log("popUpFlag", popUpFlag);
          drivingApi({
            employee_id: data.map((e) => e.employee_id),
            driving_status: statusCode,
          });
        } else {
          console.log("popUpFlag", popUpFlag);
          console.log(popUpFlag);
          setPopUp(true);
        }
      } else {
        dispatch(
          setAppError({
            msg: "Please Select Vaild Emp",
          })
        );
      }
    }
  };

  const drivingApi = async (type) => {
    const reqObj = {
      driving_status: type.driving_status === "1" ? 1 : 6,
      employee_id: type.employee_id,
    };
    console.log("Type to be printed in the console", type, selectList);
    try {
      const res = await nodeinstance.post(
        "/drivingLicense/updatestatus/",
        reqObj,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (res.status == 200) {
        dispatch(
          setAppError({
            msg: "Employee Driving License Issued",
            color: "success",
          })
        );
        setDataList([]);
        setCheckedItems({});
        updateData();
      } else {
        dispatch(
          setAppError({
            msg: err?.response?.error,
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error?.response?.error,
        })
      );
    }
  };
  const handleCheckboxChange = (event, employee_id, list) => {
    const isChecked = event.target.checked;
    setCheckedItems((prevState) => {
      const nextState = { ...prevState };
      if (isChecked) {
        nextState[employee_id] = true; // Set the checkbox state to true
      } else {
        delete nextState[employee_id]; // Remove the entry for unchecked checkboxes
      }
      return nextState;
    });
    setItemList((prevItemList) => {
      const updatedList = prevItemList.filter((item) => item !== list);
      if (isChecked) {
        updatedList.push(list);
      }
      return updatedList;
    });
  };
  const [trigger, setTrigger] = useState(false);
  return (
    <>
      <div className="relative bg-white">
        <div className="overflow-x-auto max-h-[70vh]">
          <div className="sticky top-0 z-10 min-w-[1000px]">
            <div className="grid grid-cols-table-ajeer-applied gap-5 p-6 text-center">
              {titleList.map((t, index) => (
                <p key={index} className="font-semibold uppercase">
                  {t}
                </p>
              ))}
            </div>
          </div>
          <div>
            {/* {list?.data.isLoading && (
              <LoadingWithLable className="col-span-6" />
            )} */}
            {list?.data?.listData.map((listData, index) => (
              <a
                key={index}
                onClick={() => {
                  const filteredData = list?.data.data.filter(
                    (indexData) =>
                      indexData.visa_provider === listData.visa_provider &&
                      indexData.client_name === listData.client_name &&
                      indexData.driving_status === listData.driving_status
                  );
                  setStatus(listData.driving_status_value);
                  if (listData.driving_status_value == 2) {
                    setSeletedList([
                      { value: "REJECT" },
                      { value: "Update Details" },
                    ]);
                  }
                  setNewCurrentList(filteredData);
                  setIndex(index);
                }}
                className={`grid grid-cols-table-ajeer-applied auto-cols-min gap-5 p-4 text-center ${indexValue === index ? "bg-orange-50" : "bg-white"} rounded-md `}
                style={{ cursor: "pointer" }} // Apply pointer cursor style
              >
                <React.Fragment key={index}>
                  <PaginationIndex index={index} />
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={listData.visa_provider || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={listData.client_name || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={
                        listData.employee_count.toString() || "-"
                      }
                    />
                  </p>
                  <p className="overflow-x-hidden">
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={listData.sponsor_id || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={listData.driving_status || "-"}
                    />
                  </p>
                  {/* {indexValue === index ? <></> : <hr
                    className={`border-[1px] border-slate-100  w-full col-span-full `}
                  />} */}
                </React.Fragment>
              </a>
            ))}
          </div>
        </div>
      </div>

      {currentList.length !== 0 ? (
        <>
          <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
            <Search
              searchKey={[
                "employee_id",
                "visa_reference_number",
                "border_number",
              ]}
              setSearchWords={setSearchWords}
            />
            {newCurrentList[0].driving_status_value === 4 ? (
              <button
                className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
                onClick={() => setPopUpDoc(true)}
              >
                <p>UPLOAD BULK DOCUMENT</p>
              </button>
            ) : (
              <></>
            )}
            {newCurrentList[0].driving_status_value !== 4 ? (
              status === 5 ? (
                <button
                  className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
                  onClick={() => popOpenIssued()}
                >
                  <p>Update status Licence issued</p>
                </button>
              ) : (
                <button
                  className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
                  onClick={() => popOpen()}
                >
                  <p>Update</p>
                </button>
              )
            ) : (
              <></>
            )}
            {status === 5 ? (
              <></>
            ) : Object.entries(checkedItems)
                .filter(([emp_id, isChecked]) => isChecked)
                .map(([emp_id]) => emp_id).length !== 0 ? (
              <div className="">
                <select
                  className="select select-bordered select-sm w-full h-10"
                  defaultValue={{ label: "Choose", value: "placeholder" }}
                  onChange={(e) => {
                    setDataList([]);
                    const selectedValue = e.target.value;
                    if (selectedValue === "Update Details") {
                      setPopUpFlag(true);
                      const data = listChecked.filter((indexData) =>
                        indexData.driving_status_value === null
                          ? ""
                          : indexData.driving_status_value.toString() === "2"
                      );
                      if (data.length !== 0) {
                        setPopUpFlag(true);
                        setDataList(data);
                      }
                    } else if (selectedValue === "REJECT") {
                      const data = listChecked.filter((indexData) =>
                        indexData.driving_status_value === null
                          ? ""
                          : indexData.driving_status_value.toString() === "2"
                      );
                      console.log(data);
                      setDataList(data);
                      setPopUpFlag(false);
                      setStatusCode("1");
                    } else {
                      setPopUpFlag(false);
                      setStatusCode("");
                      setDataList([]);
                    }
                  }}
                >
                  <option value="placeholder" hidden>
                    Choose
                  </option>
                  {selectList.map((value) => (
                    <option key={value.value} value={value.value}>
                      {value.value}
                    </option>
                  ))}
                </select>
              </div>
            ) : (
              <></>
            )}
          </div>

          <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
          <CountPerPage />
          <div className="relative bg-white">
            <div className="overflow-x-auto max-h-[70vh] ">
              <div className="sticky top-0 z-10 bg-white min-w-[2550px]">
                <div className="grid grid-cols-table-update-lic gap-5 p-6 text-center">
                  {titles.map((t, index) => (
                    <p key={index} className="font-semibold uppercase">
                      {t}
                    </p>
                  ))}
                </div>
              </div>
              <div className="grid grid-cols-table-update-lic gap-5 p-6 bg-white text-center">
                {list?.isLoading && (
                  <LoadingWithLable className="col-span-full" />
                )}
                {!list?.isLoading && <NoDataFound />}
                {!list?.isLoading &&
                  currentList.map((list, index) => (
                    <React.Fragment key={index}>
                      <PaginationIndex index={index} />
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.employee_id || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.name || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.actual_profession || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.visa_profession || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.visa_provider || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.sponsor || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.client_name || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.iqama_number || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.license_type || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.apply_date || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.issue_date || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.expiry_date || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.valid_days || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.admission_fee || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.medical_fee || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.govt_fee || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.inducement_fee || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.driving_status || "-"}
                        />
                      </p>
                      {newCurrentList[0].driving_status_value !== 4 &&
                      newCurrentList[0].driving_status_value !== 6 ? (
                        <div>
                          <input
                            // disabled={list.baladiya_status === "Baladiya Location Updated" ? true : false}
                            key={list.employee_id} // Use a unique identifier as the key
                            type="checkbox"
                            checked={checkedItems[list.employee_id] || false}
                            onChange={(event) =>
                              handleCheckboxChange(
                                event,
                                list.employee_id,
                                list
                              )
                            }
                          />
                        </div>
                      ) : (
                        <></>
                      )}
                      <hr
                        className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                      />
                    </React.Fragment>
                  ))}
              </div>
            </div>
          </div>

          <Pagination />
        </>
      ) : (
        <></>
      )}

      {Popup ? (
        <UpdateDetailsPopup
          list={Object.entries(checkedItems)
            .filter(([emp_id, isChecked]) => isChecked)
            .map(([emp_id]) => emp_id)}
          PopUp={Popup}
          setPopUp={setPopUp}
          title={"UPDATE DRIVING LICENSE DETAILS"}
          url={"/drivingLicense/Updatelicense"}
          callBack={apiCall}
          token={token}
        />
      ) : (
        ""
      )}

      {popOpenDoc ? (
        <DocumentUploadFilePopUp
          PopUp={popOpenDoc}
          setPopUp={setPopUpDoc}
          title={"Bulk UPLOAD Documents"}
          url={`/drivingLicense/bulkuploadLicenseDoc/`}
          callBack={updateData}
          fileFormat={"> Driving-License-Iqama Number"}
          fileNme={"Driving-License-Iqama Number"}
          setTrigger={setTrigger}
          trigger={trigger}
        />
      ) : (
        ""
      )}
    </>
  );
}
